<ul class="fa-ul mb-0 ms-3 usp-block">
  @for (usp of usps; track usp) {
    <li wlCSCapture>
      <crnt-icon
        class="fa-li text-success"
        icon="check"
        size="large"
      ></crnt-icon
      >{{ usp }}
    </li>
  }
</ul>
